import axios from "axios";
import fun2win from "../../router/fun2win";
import country_list from "../../locales/country_list.json";
const host = window.location.host;
const parts = host.split(".");
const currentDate = new Date();

//get number of week
function getWeekNumber(d) {
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  // Get first day of year
  var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  // Return array of year and week number
  return weekNo;
}
var week = getWeekNumber(currentDate);

let res = Number(parts[1]);
let type = Number.isInteger(res);
let gcid = "";

if (type == true) {
  gcid = parts[1];
} else {
  gcid = "";
}

const state = {
  //auth
  langButton_f2w: ``,
  country_f2w: parts[0],
  lang_f2w: localStorage.getItem("lang_f2w"),
  authentication_f2w: "",
  IconHotpick_f2w: require(`../../assets/fun2win/imgs/other/Hot Picks.svg`),
  IconPopular_f2w: require(`../../assets/fun2win/imgs/other/Populars.svg`),
  //notification.vue
  notification_f2w: {},
  HotPicksPage_f2w: {},
  PopularPage_f2w: {},
  host_f2w: host,
  gcid_f2w: gcid
  // number_of_week: week
};

const getters = {
  gcid_f2w: state => state.gcid_f2w,
  IconHotPick_f2w: state => state.IconHotpick_f2w,
  IconPopular_f2w: state => state.IconPopular_f2w,
  notification_f2w: state => state.notification_f2w,
  authentication_f2w: state => state.authentication_f2w,
  HotPicksPage_f2w: state => state.HotPicksPage_f2w,
  PopularPage_f2w: state => state.PopularPage_f2w,
  langButton_f2w: state => state.langButton_f2w,
  lang_f2w: state => state.lang_f2w,
  country_f2w: state => state.country_f2w,
  host_f2w: state => state.host_f2w
  // number_of_week: state => state.number_of_week
};

const actions = {
  async fetchLanguage_f2w({ commit }, lang) {
    for (let [key, value] of Object.entries(country_list)) {
      if(lang == value.language){
        lang = value.language
      }else{
        //english
        lang = lang
      }
    }
    
    commit("setLanguage", lang);
  },
  async fetchLanguageButton_f2w({ commit }, country) {
    for (let [key, value] of Object.entries(country_list)) {
      if(country == key){
        let button = `<button id="lang2" lang="${value.language}" class="mobiBtn sm">
        <img lang="${value.language}" src="${value.flag_rec}" />
        <span lang="${value.language}">${value.button_text}</span>
        </button>`

        commit("setButton", button);
      }
    }
  },
  async fetchHotPicks_f2w({ commit }, file) {
    let data = file[0];

    let limit = 0;

    if (file[1] != undefined) {
      limit = parseInt(
        file[1].target.options[file[1].target.options.selectedIndex].value
      );
    } else {
      //default
      limit = 200;
    }

    let response = [];
    let live = `http://cook.grabmobi.com/`;
    let local = `http://[::1]/PuretechGlobalContentPortal`;

    if (data == undefined) {
      response = await axios.get(
        `${live}/api/contents/newcontents_categories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&category=game&limit=${limit}&offset=0&domain=${host}`
      );
    } else {
      response = await axios.get(
        `${live}/api/contents/newcontents_subcategories?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&subcategory=${data}&limit=${limit}&offset=0&domain=${host}`
      );
    }

    response.data.data.sort((a, b) =>
      a.cont_name_english.localeCompare(b.cont_name_english)
    );

    commit("setPageHotPicks", response.data.data);
  },
  async fetchPopular_f2w({ commit }, e) {
    let limit = 0;

    if (e != undefined) {
      limit = parseInt(e.target.options[e.target.options.selectedIndex].value);
    } else {
      //default
      limit = 200;
    }

    let live = `http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=&limit=${limit}&offset=0&domain=${host}`;
    let local = `http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=&limit=${limit}&offset=0&domain=${host}`;

    let response = await axios.get(live);

    let data = response.data.data;

    data.sort(function(a, b) {
      //to sort random
      return b.rating - a.rating;
    });
    commit("setPagePopular", data);
  },
  async fetchTokenID_f2w({ commit, dispatch }, id) {
    let auth = "";
    let check = "";
    let proxyurl = "https://cors-anywhere.herokuapp.com/";

    let token = localStorage.getItem("userTokenID_f2w");
    if (token != null) {
      //checking if have token
      auth = token;
    } else {
      //checking if have param id
      auth = id;
    }

    if (auth != undefined) {
      //to check if token has numbers and letters
      // check = dispatch("checkTokenID_f2w", auth);
      auth = auth.toLowerCase();
      var letterNumber = '^(?:[0-9]+[a-zA-Z]|[a-zA-Z]+[0-9])[a-z0-9#$@!]*$';
      if (auth.match(letterNumber)) {
        check = true
      } else {
        check = false
      }
    } else {
      // fun2win.push({ name: "Login" }).catch(err => {});
    }

    if (check == true) {
      //if check is true
      let data = {
        code: auth,
        verbose: "1"
      };

      if (token != null) {
        localStorage.setItem("userTokenID_f2w", data.code);
        commit("setAuth", "loggedin");
        // EventBus.$emit("logged-in", "loggedin");
      } else {
        let response = await axios.post(
          `${proxyurl}http://gateway.puretechglobal.net/gateway_request/api/sub/?code=${data.code}&verbose=${data.verbose}`
        );

        if (response.data.status == "active") {
          localStorage.setItem("userTokenID_f2w", data.code);
          commit("setAuth", "loggedin");
          fun2win.push({ name: "Home" }).catch(err => {});
          // location.reload();
        } else if (response.data.status == "inactive") {
          if (data.code != undefined) {
            alert(response.data.status.toUpperCase());
          }
          // fun2win.push({ name: "Login" }).catch(err => {});
        }
      }
    } else {
      //if check is false
      // mobizone.push({ name: "Login" }).catch(err => {});
    }
  },
  async checkTokenID_f2w({ commit }, auth) {
    var letterNumber = /^[0-9a-zA-Z]+$/;
    if (auth.match(letterNumber)) {
      return true;
    } else {
      return false;
    }
  },
  async subscribeContent_f2w({ commit }, file) {
    let token = localStorage.getItem("userTokenID_f2w");
    let lang = localStorage.getItem("lang_f2w");
    let alert_pop = "";

    let alert_lang = require(`../../locales/fun2win/${lang}.json`);
    alert_pop = alert_lang.not_subs;

    if (token != null) {
      if (file[1] != "application/x-zip-compressed") {
        window.location.href = file[0];
        // window.open(file[0], "download");
      } else {
        window.open(file[0], "_blank");
      }
    } else {
      alert(alert_pop);

      setTimeout(() => {
        fun2win.push({ name: "Login" }).catch(err => {});
      }, 1000);
    }
  },
  async login_f2w({ commit }, loginAuth) {
    commit("setAuth", loginAuth);
  },
  async fetchNotification_f2w({ commit }) {
    let notify = [];
    let date = currentDate.getUTCDate();
    let w = week % 2;

    if (w != 0) {
      date = date + 10;
    }

    let live = `http://cook.grabmobi.com/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=&limit=5&offset=${date}&domain=${host}`;
    let local = `http://[::1]/PuretechGlobalContentPortal/api/newcontents?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&id=&category=game&subcategory=&limit=10&offset=0&domain=${host}`;

    let res = await axios.get(live);

    let data = res.data.data.slice(0, 5);

    let noti = data.map(noti => {
      let sub_trans = JSON.parse(noti.subcategory_translate);
      // console.log(noti.created_time)
      let trans_len = Object.keys(sub_trans).length;
      let trans_arr = Object.keys(sub_trans);

      noti.titleSub_english = noti.subcategory;
      if (sub_trans != null || sub_icon != null) {
        for (let i = 0; i < trans_len; i++) {
          noti["titleSub_" + trans_arr[i]] = sub_trans[trans_arr[i]].title;
        }
      }

      return noti;
    });

    if (w == 0) {
      //name ascending
      noti.sort((a, b) =>
        a.cont_name_english.localeCompare(b.cont_name_english)
      );
    } else {
      //name descending
      noti.sort((a, b) =>
        b.cont_name_english.localeCompare(a.cont_name_english)
      );
    }

    notify = noti.slice(0, 5);

    commit("setNotification", notify);
  }
};

const mutations = {
  setNotification: (state, response) => (state.notification_f2w = response),
  setAuth: (state, response) => (state.authentication_f2w = response),
  setPageHotPicks: (state, response) => (state.HotPicksPage_f2w = response),
  setPagePopular: (state, response) => (state.PopularPage_f2w = response),
  setButton: (state, response) => (state.langButton_f2w = response),
  setLanguage: (state, response) => (state.lang_f2w = response)
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/fun2win-store.js